import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { DollarSign } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function BeautyClinicsRevenuePage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Relatório de Receitas"
      description="Análise financeira das receitas da clínica."
      icon={DollarSign}
    />
  
    </MainLayout>);
}

